/** fileName: Loading.jsx
 * developer: majid.garavand@gmail.com
 * created: 3/17/23
 * note: Do not delete this comment to maintain copyright rules
 * */
import {Box, Typography} from "@mui/material";
import CircularProgress from "@mui/material/CircularProgress";
import React from 'react';
import './Loading.css';

const Loading = ({placeHolder = false, sx = null, loadingText = ''}) => {
    let defStyle = {
        left: placeHolder ? 'auto' : "50%",
        top: placeHolder ? 'auto' : "50%",
        transform: placeHolder ? '0, 0' : "translate(-50%,-50%)",
        position: placeHolder ? 'static' : "fixed",
        display: "flex",
        flexDirection: "column",
        height: "100px",
        width: "100px",
        zIndex: 99999,
        alignItems: "center",
        justifyContent: "space-between"
    };


    const ParentChild = ({children}) => {
        return placeHolder ? (<Box className={'parentChild'}
                                   sx={{
                                       maxWidth: placeHolder ? 100 : '100%',
                                       maxHeight: placeHolder ? 100 : '100%',
                                       margin: 'auto',
                                   }}>{children}
        </Box>) : (children);
    }


    return (
        <ParentChild>
            <div style={defStyle}>
                <CircularProgress className={'loading'} sx={sx}/>
                <Typography className={'body-small'}
                            sx={{
                                marginTop: '50px',
                                // transform: placeHolder ? '0, 0' : "translate(50%,0px)",
                            }}>
                    {loadingText}
                </Typography>
            </div>

        </ParentChild>
    );
};

export default Loading;